import { Center, Text, Button, Stack, Image } from "@mantine/core";

export default function ThankYouPage({ handleReset }) {
	return (
		<Stack
			px="8.14vw"
			pt="24.42vw"
			pb="11.63vw"
			align="center"
			justify="space-between"
			h="100vh"
		>
			<Image
				src={window.assetUrl("/images/liff/questionnaire-page/logo.png")}
				alt="Tory Burch"
				w="58%"
			/>

			<Center>
				<Text align="center" size="3.76vw" lh="1.4">
					感謝您抽空填寫，我們非常重視您的寶貴意見，
					<br />
					並會作為未來改進的重要依據。
				</Text>
			</Center>

			<Stack w="100%">
				<Button
					fullWidth
					radius="xl"
					size="lg"
					color="black"
					style={{
						border: "2px solid #DDDDDD",
					}}
					onClick={handleReset}
				>
					回到首頁
				</Button>
				<Button
					fullWidth
					variant="transparent"
					radius="xl"
					size="lg"
					color="black"
				/>
			</Stack>
		</Stack>
	);
}
